import React from 'react';

//composants
import Calendar from "../../calendar.js";

//utiles
import { toDateString } from "../../../utils/formatting.js";

const CustomInputWithCalendar = ({ texts, dateSelected, onChangeValue, setdateIsSelected, setIsOpenCalendar, isOpenCalendar, calendarRef, minDate, maxDate, error, initialMonth }) => {

    const calendarClicked = (date) => {
        if (onChangeValue(date) !== false) {
            setdateIsSelected(true);
        }
        setIsOpenCalendar(false)
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return (
        <div className='container-custum-input-calendar' ref={calendarRef}>
            <div className="sub-title-section"><span className="droit-acces-span">{texts.calendarQuestion}</span></div>
            {error &&
                <div className="fec-field-error">{error}</div>
            }
            <div style={{ display: 'flex' }}>
                <div style={{ position: 'relative', display: 'flex' }}>
                    {/* input */}
                    <input
                        style={{ width: '170px', fontSize: '2em', textAlign: 'center' }}
                        type="text"
                        placeholder={texts.datePlaceholder}
                        value={toDateString(dateSelected)}
                        readOnly={true}
                        className="droit-acces-input clickable"
                        onMouseDown={e => setIsOpenCalendar(!isOpenCalendar)}
                    />

                    {isOpenCalendar && (
                        // Composant Calendrier
                        <div className="content-calendar">
                            <Calendar
                                initialMonth={initialMonth || new Date()}
                                onDayClick={date => calendarClicked(date)}
                                minDate={minDate || new Date(1900, 0, 1)}
                                maxDate={maxDate || today}
                                indisponibilites={[]}
                                dateActivite={null}
                                isActivite={true}
                            />
                        </div>
                    )}
                    {/* Image calendrier */}
                    <div style={{ marginLeft: '20px', cursor: 'pointer' }}>
                        <img
                            src={require('../../../../images/icons/calendar-2.png')}
                            alt={texts.calendarAlt}
                            onMouseDown={e => setIsOpenCalendar(!isOpenCalendar)}
                            className="droit-acces-img"
                            width={40}
                        />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default CustomInputWithCalendar;